import {Navigate, redirect} from 'react-router';
import {serviceRoutes} from './services/routes';

export const settingsRoutes = [
  {
    // Phone: the section index. From 900px (theme breakpoint md) the side
    // list shows the sections, so it lands on preferences — in the loader,
    // before the index chunk loads or an empty "Settings" page commits.
    path: '',
    loader: () =>
      window.matchMedia('(min-width:900px)').matches
        ? redirect('/app/settings/preferences')
        : null,
    lazy: () => import('./SettingsIndex'),
  },
  {
    path: 'account',
    lazy: () => import('../../../screens/settings/AccountScreen'),
  },
  {
    path: 'premium',
    lazy: () => import('../../../screens/settings/PremiumScreen'),
  },
  {
    path: 'premium/success',
    lazy: () =>
      import('../../../screens/settings/PremiumScreen/SubscriptionSuccess'),
  },
  {
    path: 'premium/donate/success',
    lazy: () =>
      import('../../../screens/settings/PremiumScreen/DonationSuccess'),
  },
  {
    path: 'preferences',
    lazy: () => import('../../../screens/settings/PreferenceScreen'),
  },
  {
    path: 'services',
    children: serviceRoutes,
  },
  {
    // Absolute: a relative `to` inside a splat route resolves under the
    // splat (/app/settings/nope/preferences), which matches `*` again — the
    // old "preferences" redirect looped forever.
    path: '*',
    element: <Navigate to="/app/settings/" replace />,
  },
];
